import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

import { LabeledValue } from "../components";

import type { CarriersRepDirectoryStats } from "../types";

interface CarriersRepDirectoryHeaderProps {
  stats: CarriersRepDirectoryStats;
}

export const CarriersRepDirectoryHeader = ({
  stats,
}: CarriersRepDirectoryHeaderProps): React.JSX.Element => {
  const counters = [
    { label: "Carriers", value: stats.carriers },
    { label: "Active Reps", value: stats.activeReps },
    { label: "Rules", value: stats.rules },
    { label: "Needs Review", value: stats.needsReview },
  ];

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <Typography variant="header-large" component="h1">
        Carrier Rep Directory
      </Typography>

      <Box display="flex" gap={2}>
        {counters.map(({ label, value }) => (
          <LabeledValue key={label} label={label} value={value} />
        ))}
      </Box>
    </Box>
  );
};
